import brujahSymbol from '../assets/brujahImages/brujahSymbol02.png'
import brujahImage from '../assets/brujahImages/brujah_couple.png'
import brujahCoupleAnarks from '../assets/brujahImages/brujah_couple_anarks.png'
import toreadorImage from '../assets/toreadorImages/toreador_couple.png'
import toreadorSymbol from '../assets/toreadorImages/toreador_symbol.png'
import gangrelImage from '../assets/gangrelImages/gangrel_couple.png'
import gangrelSymbol from '../assets/gangrelImages/gangrel_symbol.png'
import gangrelCoupleAnarks from '../assets/gangrelImages/gangrel_couple_anarks.png'
import ventrueImage from '../assets/ventrueImages/ventrue_couple.png'
import ventrueSymbol from '../assets/ventrueImages/ventrue_symbol.png'
import malkavianImage from '../assets/malkaviansImages/malkaviansTwins.png'
import malkavianSymbol from '../assets/malkaviansImages/malkavianSymbol.png'
import nosferatuImage from '../assets/nosferatuImages/nosferatu_couple.png'
import nosferatuSymbol from '../assets/nosferatuImages/nosferatuSymbol.png'
import tremereImage from '../assets/tremereImages/couple_Tremere.png'
import tremereSymbol from '../assets/tremereImages/tremereSymbol.png'
import lasombraImage from '../assets/lasombraImages/lasombra_couple.png'
import lasombraSymbol from '../assets/lasombraImages/lasombraSymbol.png'
import tzimisceImage from '../assets/tzimisceImages/tzimisce_couple.png'
import tzimisceSymbol from '../assets/tzimisceImages/tzimisceSymbol.png'
import assamitaImage from '../assets/assamitaImages/assamita_couple.png'
import assamitaSymbol from '../assets/assamitaImages/assamitaSymbol.png'
import ravnoImage from '../assets/ravnoImages/ravno_couple.png'
import ravnosSymbol from '../assets/ravnoImages/ravnosSymbol.png'
import setitaImage from '../assets/setitaImages/setita_couple.png'
import setitaSymbol from '../assets/setitaImages/setitaSymbol.png'
import giovanniImage from '../assets/giovanniImages/giovanni_couple.png'
import giovanniSymbol from '../assets/giovanniImages/giovanniSymbol.png'

export const clansData = {
  camarilla: {
    name: 'Camarilla',
    description: 'A Torre de Marfim dos vampiros civilizados. A Camarilla é a maior e mais organizada das seitas vampíricas, favorecendo tradições e o controle discreto da população mortal.',
    clans: [
      {
        id: 'brujah',
        name: 'Brujah',
        nickname: 'Os Rebeldes',
        description: 'Anarquistas, desordeiros e desafiadores da autoridade. Eram grandes filósofos nas civilizações antigas, mas viram seu império cair. Agora usam sua força sobrenatural para fazer baderna e destruir tudo pela frente.',
        disciplines: ['Potência', 'Rapidez', 'Presença'],
        characteristics: 'Força física, velocidade, temperamento explosivo, paixão pela liberdade',
        weakness: 'Dificuldade para controlar a fúria, tendência ao frenesi',
        symbol: brujahSymbol,
        image: brujahImage
      },
      {
        id: 'gangrel',
        name: 'Gangrel',
        nickname: 'Os Selvagens',
        description: 'O clã mais feral e bestial. Criaturas nômades que evitam cidades, conhecidos por sua relação com animais. Podem se comunicar e controlar animais, além de assumir formas animalescas.',
        disciplines: ['Metamorfose', 'Animalismo', 'Fortitude'],
        characteristics: 'Conexão com a natureza, forma animal, resistência, nomadismo',
        weakness: 'Características animais permanentes após frenesi',
        symbol: gangrelSymbol,
        image: gangrelImage
      },
      {
        id: 'malkaviano',
        name: 'Malkaviano',
        nickname: 'Os Lunáticos',
        description: 'Unidos pela loucura. Todos sofrem de graves perturbações psicológicas, mas sua demência é também sua maior força, permitindo manipular a sanidade de outros.',
        disciplines: ['Demência', 'Auspícios', 'Ofuscação'],
        characteristics: 'Loucura, intuição sobrenatural, percepção alterada da realidade',
        weakness: 'Insanidade permanente e incurável',
        symbol: malkavianSymbol,
        image: malkavianImage
      },
      {
        id: 'nosferatu',
        name: 'Nosferatu',
        nickname: 'Os Esgotos',
        description: 'Seres grotescos com aparência apavorante, resultado da maldição que os obriga a carregar suas "bestas interiores" no exterior. Vivem nos esgotos e são excelentes espiões.',
        disciplines: ['Ofuscação', 'Animalismo', 'Potência'],
        characteristics: 'Aparência horrenda, furtividade, rede de informações',
        weakness: 'Aparência monstruosa que quebra a Máscara',
        symbol: nosferatuSymbol,
        image: nosferatuImage
      },
      {
        id: 'toreador',
        name: 'Toreador',
        nickname: 'Os Degenerados',
        description: 'Vampiros artísticos fascinados pelo mundo mortal. Sedutores, belos e glamourosos, são próximos dos humanos e inspiram romances vampíricos.',
        disciplines: ['Rapidez', 'Presença', 'Auspícios'],
        characteristics: 'Beleza, arte, sedução, fascínio pelo mundo mortal',
        weakness: 'Paralisia diante da beleza extrema',
        symbol: toreadorSymbol,
        image: toreadorImage
      },
      {
        id: 'tremere',
        name: 'Tremere',
        nickname: 'Os Feiticeiros',
        description: 'Magos poderosos que controlam a Magia do Sangue. Inteligentíssimos, manipulam grandes organizações pelas sombras e são capazes de trabalhar feitiços e alquimia.',
        disciplines: ['Taumaturgia', 'Auspícios', 'Dominação'],
        characteristics: 'Magia do sangue, hierarquia rígida, conhecimento arcano',
        weakness: 'Ligação de sangue com superiores hierárquicos',
        symbol: tremereSymbol,
        image: tremereImage
      },
      {
        id: 'ventrue',
        name: 'Ventrue',
        nickname: 'Os Reis',
        description: 'Figuras clássicas e sedutoras dos vampiros. Ricos e poderosos, estão por trás dos maiores impérios e organizações políticas, dominando a Camarilla.',
        disciplines: ['Dominação', 'Fortitude', 'Presença'],
        characteristics: 'Liderança, riqueza, poder político, nobreza',
        weakness: 'Alimentação restrita a tipos específicos de sangue',
        symbol: ventrueSymbol,
        image: ventrueImage
      }
    ]
  },
  sabbat: {
    name: 'Sabbat',
    description: 'A Espada de Caim. Uma seita que não acredita no valor das tradições vampíricas, abraçando a Besta interior e rejeitando a humanidade.',
    clans: [
      {
        id: 'lasombra',
        name: 'Lasombra',
        nickname: 'Os Guardiões',
        description: 'Fundadores do Sabbat. Nobres ricos e poderosos, rivais dos Ventrue. Adoram as trevas como divindade e dominam as sombras, não aparecendo em espelhos.',
        disciplines: ['Tenebrosidade', 'Dominação', 'Potência'],
        characteristics: 'Manipulação das sombras, liderança, ausência de reflexo',
        weakness: 'Não aparecem em espelhos ou superfícies reflexivas',
        symbol: lasombraSymbol,
        image: lasombraImage
      },
      {
        id: 'tzimisce',
        name: 'Tzimisce',
        nickname: 'Os Demônios',
        description: 'Extremamente poderosos e antigos. Dominam a Vicissitude, manipulando carne e ossos, torturando e alterando corpos. O clã do Conde Drácula.',
        disciplines: ['Vicissitude', 'Animalismo', 'Auspícios'],
        characteristics: 'Manipulação corporal, territorialismo, nobreza sombria',
        weakness: 'Necessidade de dormir em solo nativo',
        symbol: tzimisceSymbol,
        image: tzimisceImage
      }
    ]
  },
  anarquistas: {
    name: 'Movimento Anarquista',
    description: 'Liberdade contra as antigas tradições. Vampiros que rejeitam tanto a Camarilla quanto o Sabbat, buscando formas alternativas de existência.',
    clans: [
      {
        id: 'brujah_anarquista',
        name: 'Brujah',
        nickname: 'Os Revolucionários',
        description: 'Muitos Brujah se juntaram ao Movimento Anarquista, encontrando nele a expressão perfeita de sua natureza rebelde e anti-autoritária.',
        disciplines: ['Potência', 'Rapidez', 'Presença'],
        characteristics: 'Revolução, liberdade, resistência ao poder estabelecido',
        weakness: 'Dificuldade para controlar a fúria',
        symbol: brujahSymbol,
        image: brujahCoupleAnarks
      },
      {
        id: 'gangrel_anarquista',
        name: 'Gangrel',
        nickname: 'Os Independentes',
        description: 'Muitos Gangrel abandonaram a Camarilla para se juntar aos Anarquistas, valorizando a liberdade e independência.',
        disciplines: ['Metamorfose', 'Animalismo', 'Fortitude'],
        characteristics: 'Independência, sobrevivência, conexão com a natureza',
        weakness: 'Características animais após frenesi',
        symbol: gangrelSymbol,
        image: gangrelCoupleAnarks
      }
    ]
  },
  independentes: {
    name: 'Clãs Independentes',
    description: 'Clãs que não se alinham com nenhuma seita principal, mantendo sua própria agenda e objetivos.',
    clans: [
      {
        id: 'assamitas',
        name: 'Assamitas (Banu Haqim)',
        nickname: 'Os Assassinos',
        description: 'Assassinos silenciosos do Oriente Médio. Trabalham como mercenários e possuem a Disciplina da Morte Silenciosa, controlando o sangue de suas vítimas.',
        disciplines: ['Quietus', 'Rapidez', 'Ofuscação'],
        characteristics: 'Assassinato, honra, justiça, mercenários',
        weakness: 'Sede de sangue vampírico (diablerie)',
        symbol: assamitaSymbol,
        image: assamitaImage
      },
      {
        id: 'giovanni',
        name: 'Giovanni (Hecata)',
        nickname: 'A Família',
        description: 'A máfia vampírica. Só transformam membros da família mortal, envolvem-se com necromancia e dizimaram os Capadócios para tomar seu lugar.',
        disciplines: ['Necromancia', 'Dominação', 'Potência'],
        characteristics: 'Necromancia, família, negócios, morte',
        weakness: 'Beijo causa dor excruciante',
        symbol: giovanniSymbol,
        image: giovanniImage
      },
      {
        id: 'ravnos',
        name: 'Ravnos',
        nickname: 'Os Charlatões',
        description: 'Vagabundos e nômades que viajam pelo mundo como charlatões. Dominam o Quimerismo, criando ilusões e se comunicando com animais.',
        disciplines: ['Quimerismo', 'Animalismo', 'Fortitude'],
        characteristics: 'Ilusões, nomadismo, trapaça, liberdade',
        weakness: 'Compulsão por vícios específicos',
        symbol: ravnosSymbol,
        image: ravnoImage
      },
      {
        id: 'seguidores_set',
        name: 'Seguidores de Set (Ministério)',
        nickname: 'Os Serpentes',
        description: 'Adoradores do deus egípcio Set. Dedicam-se a corromper e destruir, manipulando poderes de serpente como hipnose e línguas bifurcadas.',
        disciplines: ['Serpentis', 'Ofuscação', 'Presença'],
        characteristics: 'Corrupção, tentação, conhecimento proibido',
        weakness: 'Sensibilidade extrema à luz',
        symbol: setitaSymbol,
        image: setitaImage
      }
    ]
  }
}

export default clansData

